function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { bool, func, number, object, string } from 'prop-types';
import { styled } from '@mui/material/styles';
import MuiChip, { chipClasses } from '@mui/material/Chip';
import SovosFixedWidthText from '../../../sovos-fixed-width-text';
import { getAfterFocusStyles } from '../../utils';
const StyledChip = styled(MuiChip, {
  shouldForwardProp: prop => prop !== 'maxWidth' && prop !== 'selected'
})(_ref => {
  let {
    maxWidth,
    selected,
    theme: {
      palette,
      spacing,
      typography
    }
  } = _ref;
  return {
    ...typography.body1,
    height: spacing(4),
    maxWidth,
    backgroundColor: selected ? undefined : palette.action.disabledBackground,
    ["& .".concat(chipClasses.label)]: {
      padding: "".concat(spacing(0.75), " ").concat(spacing(2))
    },
    '&:focus-visible': {
      ...getAfterFocusStyles()
    }
  };
});
const Chip = _ref2 => {
  let {
    classes,
    disabled = false,
    label,
    maxWidth,
    selected,
    ...rest
  } = _ref2;
  const renderedLabel = maxWidth ? /*#__PURE__*/React.createElement(SovosFixedWidthText, {
    text: label
  }) : label;
  return /*#__PURE__*/React.createElement(StyledChip, _extends({
    classes: classes,
    color: selected ? 'primary' : 'default',
    disabled: disabled,
    label: renderedLabel,
    maxWidth: maxWidth,
    selected: selected
  }, rest));
};
Chip.propTypes = {
  classes: object,
  disabled: bool,
  label: string.isRequired,
  maxWidth: number,
  onClick: func,
  selected: bool
};
export default Chip;